/**
 * **영업 메일 유입 한 번을 받아 적는다** — 보관(`utils/attribution/outreach-touch`) + `outreach_landed` 한 줄.
 *
 * 문서 로드 하나에 한 번만 본다. 새로고침은 새 로드라 다시 적는다(판정은 admin). 수신거부 화면은 세지 않는다.
 * admin 웹훅으로 가는 클릭 보고(`OutreachClickTracker`)와는 따로다 — 그쪽은 발송 이력, 여기는 활동 로그다.
 */

import { readBrowserStorage, isOutreachTrackedPath } from 'src/utils/outreach/outreach-ref';
import { parseOutreachTouch, storeOutreachTouch } from 'src/utils/attribution/outreach-touch';

import { track } from './client';

let captured = false;

/** Provider 가 맥락·`page_viewed` 를 넣은 뒤 부른다 — 메일 유입이 아니면 아무것도 안 한다 */
export function captureOutreachLanding(): void {
  if (captured || typeof window === 'undefined') return;
  captured = true;

  if (!isOutreachTrackedPath(window.location.pathname)) return;
  const touch = parseOutreachTouch(window.location.href, document.referrer || '');
  if (!touch) return;

  const local = readBrowserStorage('local');
  const { isFirstTouch } = local ? storeOutreachTouch(local, touch) : { isFirstTouch: false };

  track({
    name: 'outreach_landed',
    type: 'action',
    props: {
      cm: touch.cm,
      utm_source: touch.utm_source,
      utm_medium: touch.utm_medium,
      utm_campaign: touch.utm_campaign,
      utm_content: touch.utm_content,
      utm_term: touch.utm_term,
      landing_url: touch.landing_url,
      referrer: touch.referrer,
      is_first_touch: isFirstTouch,
    },
  });
}

/** 테스트용 — 표식을 처음으로 */
export function resetOutreachLandingForTests(): void {
  captured = false;
}
